import { render, staticRenderFns } from "./ziliao.vue?vue&type=template&id=10933592&scoped=true"
import script from "./ziliao.vue?vue&type=script&lang=js"
export * from "./ziliao.vue?vue&type=script&lang=js"
import style0 from "./ziliao.vue?vue&type=style&index=0&id=10933592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10933592",
  null
  
)

export default component.exports